import React, { useEffect, useState } from 'react';
import AboutData from './AboutData';
import { TermFullUWCoverageLengths } from '../../Products/Term/FullUWCoverageLengths';
import PurchasingProcessData from './PurchasingProcessData';
import FaqData from './FaqData';
import TermInsuranceData from './TermArticleData';
import PolicyCostData from '../../Products/TermInsurance/PolicyCostData';
import PreQuote from '../../../../Quoters/PreQuote/PreQuote';
import IsHavenCampaign from '../Term/HavenCampaign';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../../../sessionStorage';
import TermAboutMeForm from '../../../../Quoters/CustomizeTerm/steps/AboutMeForm';
import ProductCarriers from './ProductCarriers';

export default function TermData(props) {
  const [primaryBrandColor, setPrimaryBrandColor] = useState(null);

  const minAge = 18;
  const maxAge = 70;
  const minCoverageAmount = 50000;
  const maxCoverageAmount = 10000000;
  const teaserQuoteParams = {
    faceAmount: 500000,
    termLength: 20,
    healthClass: 'PP',
  };

  const isHavenCampaign = IsHavenCampaign();
  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);

  const accountProductTypeSettings = accountObj.accountProducts.find(product => product.productLandingUrl === props.history.location.pathname);
  const accountLandingOverride = accountObj.accountOverrides && accountProductTypeSettings ?
    accountObj.accountOverrides.find(override => override.accountProductTypeId === accountProductTypeSettings.productTypeId) : null;

  useEffect(() => {
    if (!accountObj.accountOverrides) {
      setPrimaryBrandColor(accountObj.account.primaryColor);
    } else {
      setPrimaryBrandColor(accountObj.accountOverrides.primaryColor);
    }
  }, []);

  const mctForm = (<TermAboutMeForm
    ageSpecs={{ min: minAge, max: maxAge }}
    onNext={() => {
      props.history.push(props.isTermInsurance ? '/term-insurance/prequote' : '/quote/term-life-insurance/multi-carrier-term/pre-quote');
    }}
    brandTheme={primaryBrandColor}
    showHeader={false}
    submitButtonVariant={'landing'}
    isTermInsurance={props.isTermInsurance}
    teaserQuoteParams={teaserQuoteParams}
    showTestimonialPanel={true}
    term30EnableTeaserRate={accountObj.term30EnableTeaserRate}
    ref = {props.aboutMeFormRef}
  />);

  const defaultValueProposition = [{
    title: "Term Life Insurance",
    subtitle: "Protect Your Family: Plan Their Future",
    subtitleExtended: "Term life insurance is the most affordable way to secure coverage.",
  }];

  return {
    name: 'Term Life Insurance',
    subtitle: 'Click. Quote. Coverage.',
    footerMessage: "Get term insurance from start to finish completely online",
    footerButtonName: 'SEE YOUR QUOTES',
    heroText: accountLandingOverride ? JSON.parse(accountLandingOverride.valueProposition) : defaultValueProposition,
    basicInfoForm: (history) => {
      return isHavenCampaign ? <PreQuote HavenCampaign landing history={history}/> : mctForm;
    },
    about: AboutData(minAge, maxAge, minCoverageAmount, maxCoverageAmount, TermFullUWCoverageLengths()),
    purchasingProcess: PurchasingProcessData(),
    policyCost: PolicyCostData(),
    faq: FaqData(),
    termArticle: TermInsuranceData(),
    productCarriers: ProductCarriers(),
    isAddDefaultFaq: false,
  };
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/TermInsurance/TermInsuranceData.js